import { render, staticRenderFns } from "./SkeletonImage.vue?vue&type=template&id=eb3fa5b0&scoped=true"
import script from "./SkeletonImage.vue?vue&type=script&lang=js"
export * from "./SkeletonImage.vue?vue&type=script&lang=js"
import style0 from "./SkeletonImage.vue?vue&type=style&index=0&id=eb3fa5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3fa5b0",
  null
  
)

export default component.exports